var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgStar1(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 36,
    viewBox: "0 0 35 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_36_230)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M34.9088 13.9258C34.6797 13.2171 34.0511 12.7137 33.3074 12.6467L23.2054 11.7295L19.2108 2.37974C18.9163 1.69452 18.2455 1.25098 17.5002 1.25098C16.7549 1.25098 16.0841 1.69452 15.7895 2.38134L11.795 11.7295L1.6914 12.6467C0.94904 12.7154 0.322041 13.2171 0.0915888 13.9258C-0.138863 14.6345 0.0739644 15.4119 0.63554 15.9019L8.27143 22.5986L6.01978 32.5171C5.85502 33.2464 6.13808 34.0002 6.74318 34.4376C7.06843 34.6726 7.44896 34.7923 7.83269 34.7923C8.16354 34.7923 8.49173 34.7031 8.78627 34.5268L17.5002 29.3188L26.2109 34.5268C26.8483 34.9103 27.6518 34.8753 28.2556 34.4376C28.8609 33.9989 29.1437 33.2448 28.979 32.5171L26.7273 22.5986L34.3632 15.9032C34.9248 15.4119 35.1392 14.6359 34.9088 13.9258Z",
    fill: "#FFC107"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_36_230"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 35,
    height: 35,
    fill: "white",
    transform: "translate(0 0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStar1);
export default __webpack_public_path__ + "static/media/star1.06fa870ac1da11eea2b4f74a854cf146.svg";
export { ForwardRef as ReactComponent };